import CartographerLayoutStateScaffold from './CartographerLayoutStateScaffold';

export default function CartographerLayoutLoading() {
  return <CartographerLayoutStateScaffold isAnimated={true} />;
}
